import { BiEdit, BiTrash } from "react-icons/bi";
import { getUserData, getUserDataByID } from "../../services/api/AuthApi";
import { updateUnseenNotification } from "../../services/api/NotificationsApi";
import { useEffect, useMemo, useState } from "react";
import { useBubbleSettings } from "../../context/BubbleSettingsContext";
import { useNavigate } from "react-router-dom";
import draftToHtml from "draftjs-to-html";
import { formatText } from "../TruncateParties";
import DeleteConfirmationModal from "../DeleteConfirmationModal/DeleteConfirmationModal";

export const RenderTasks = ({
  tasks = [],
  setModalTab,
  setShowModal,
  onEditTask,
  onDeleteTask,
}) => {
  const navigate = useNavigate();
  const [userMap, setUserMap] = useState({});
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const { bubbleSettings, fetchAndUpdateBubbleSettings } = useBubbleSettings();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    taskId: null,
    taskName: "",
  });

  // Helper function to truncate text by word count
  const truncateText = (text, wordLimit = 40) => {
    if (!text) return "";
    const words = text.split(/\s+/);
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ");
  };

  // Helper function to get word count from plain text
  const getWordCount = (text) => {
    if (!text) return 0;
    return text.split(/\s+/).filter(word => word.length > 0).length;
  };

  // Helper function to get plain text from HTML
  const getPlainTextFromHtml = (html) => {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  // Toggle description expansion
  const toggleDescription = (taskId, e) => {
    e.stopPropagation();
    setExpandedDescriptions(prev => ({
      ...prev,
      [taskId]: !prev[taskId]
    }));
  };

  useEffect(() => {
    // Collect both assignedTo and assignedBy IDs
    const assignedToIds = tasks.flatMap((task) => task.assignedTo || []);
    const assignedByIds = tasks.map((task) => task.assignedBy).filter(Boolean);
    const allIds = [...assignedToIds, ...assignedByIds];
    const uniqueIds = [...new Set(allIds.map((id) => String(id).trim()))];

    if (uniqueIds.length > 0) {
      Promise.all(
        uniqueIds.map((id) => {
          console.log("Fetching user for ID:", id);
          return getUserDataByID(id);
        })
      )
        .then((responses) => {
          const map = {};
          responses.forEach((res, idx) => {
            const user = res?.data;
            if (user && user._id) {
              const idKey = String(user._id).trim();
              console.log("Fetched user:", user);
              map[idKey] = user;
            } else {
              console.warn("Invalid user response for:", uniqueIds[idx], res);
            }
          });
          console.log("Final userMap:", map);
          setUserMap(map);
        })
        .catch((err) => {
          console.error("Error fetching users:", err);
        });
    }
  }, [tasks]);
  const { newOrUpdatedTasks, taskNotificationMap } = useMemo(() => {
    const entries = [
      ...(bubbleSettings?.case?.highCourt || []),
      ...(bubbleSettings?.case?.districtCourt || []),
    ];

    const newOrUpdatedTasks = {};
    const taskNotificationMap = {};

    entries.forEach((entry) => {
      entry.task?.forEach((taskEntry) => {
        if (["Task Created", "Task Updated"].includes(taskEntry.action)) {
          const taskId = taskEntry.source;
          newOrUpdatedTasks[taskId] = taskEntry.action;
          taskNotificationMap[taskId] = taskEntry.id; // notification ID
        }
      });
    });

    return { newOrUpdatedTasks, taskNotificationMap };
  }, [bubbleSettings]);

  const handleDeleteClick = (e, taskId, taskName) => {
    e.stopPropagation();
    setDeleteModal({ isOpen: true, taskId, taskName });
  };

  const handleConfirmDelete = async () => {
    await onDeleteTask(deleteModal.taskId);
    setDeleteModal({ isOpen: false, taskId: null, taskName: "" });
  };

  const handleCancelDelete = () => {
    setDeleteModal({ isOpen: false, taskId: null, taskName: "" });
  };

  const handleTaskClick = async (taskId) => {
    const notificationId = taskNotificationMap[taskId];

    if (notificationId) {
      try {
        await updateUnseenNotification(notificationId);
        await fetchAndUpdateBubbleSettings(); // Immediately refresh bubble UI
      } catch (err) {
        console.error("Failed to update notification:", err);
      }
    }

    navigate(`/home/tasks/viewtask/${taskId}`);
  };

  console.log("User Map:", userMap);

  console.log(tasks, "tttttaaaskkkkkkkss");
  return (
    <>
      <div className="tab-content">
        <div className="summary">
          <div>
            <p className="margin-zero exp-count">
              <strong>Total Tasks Count:</strong> {tasks.length}
            </p>
          </div>
          <div className="tab-add">
            <button
              onClick={() => {
                setModalTab("Tasks");
                setShowModal(true);
                onEditTask(null);
              }}
            >
              Add Task
            </button>
          </div>
        </div>
        {tasks.length === 0 ? (
          <div className="no-data-container">
            <h3 className="no-data-title">No Tasks Found</h3>
            <p className="no-data-message">
              No tasks have been created for this case yet. Click "Add Task" to
              create your first task.
            </p>
          </div>
        ) : (
          tasks.map((task, index) => {
            const actionType = newOrUpdatedTasks[task._id]; // "Task Created" or "Task Updated"

            return (
              <div
                key={index}
                className="order-card"
                style={{ position: "relative", cursor: "pointer" }}
                onClick={() => handleTaskClick(task._id)}
              >
                {actionType && (
                  <span
                    className={`task-badge ${
                      actionType === "Task Created" ? "new" : "updated"
                    }`}
                    title={actionType}
                  >
                    {actionType === "Task Created" ? "New" : "Updated"}
                  </span>
                )}

                <div className="task-div-detail">
                  <div>
                    {task?.recurringTask && (
                      <p>
                        <strong>
                          Recurring {task.recurringTask.times} times a{" "}
                          {task.recurringTask.in}
                        </strong>
                      </p>
                    )}
                    <p>
                      <strong>Task Name :</strong> {task.taskName}
                    </p>

                    <p>
                      <strong>Assigned To :</strong>{" "}
                      {Array.isArray(task.assignedTo) &&
                      task.assignedTo.length > 0
                        ? task.assignedTo
                            .map((id) => userMap[id]?.name || "Unknown")
                            .join(", ")
                        : "Not Assigned"}
                    </p>

                    <p style={{ 
                      paddingRight: "20px",
                      wordBreak: "break-word",
                      maxWidth: "100%"
                    }}>
                      <strong>Description :</strong>{" "}

                      {task.description ? (
                        (() => {
                          let html = "";
                          try {
                            const raw =
                              typeof task.description === "string"
                                ? JSON.parse(task.description)
                                : task.description;
                            if (raw && raw.blocks) {
                              html = draftToHtml(raw);
                            } else {
                              html = task.description;
                            }
                          } catch (e) {
                            html = task.description;
                          }
                          // Fix anchor tags to always use absolute URLs
                          let fixedHtml = html.replace(
                            /<a ([^>]*href=["'])(?!https?:\/\/)([^"'>]+)(["'][^>]*)>/gi,
                            "<a $1https://$2$3>"
                          );

                          fixedHtml = fixedHtml.replace(
                            /<a /gi,
                            '<a target="_blank" rel="noopener noreferrer" '
                          );

                          // Get plain text for word count
                          const plainText = getPlainTextFromHtml(fixedHtml);
                          const wordCount = getWordCount(plainText);
                          const isExpanded = expandedDescriptions[task._id];

                          // Check if truncation is needed
                          if (wordCount > 40 && !isExpanded) {
                            const truncatedPlainText = truncateText(plainText, 40);
                            return (
                              <>
                                <span>{truncatedPlainText}...</span>{" "}
                                <button
                                  onClick={(e) => toggleDescription(task._id, e)}
                                  style={{
                                    padding: "2px 8px",
                                    fontSize: "12px",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    backgroundColor: "#f5f5f5",
                                    cursor: "pointer",
                                    color: "#333",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Show More
                                </button>
                              </>
                            );
                          }

                          return (
                            <>
                              <span
                                dangerouslySetInnerHTML={{ __html: fixedHtml }}
                              />
                              {wordCount > 40 && isExpanded && (
                                <>
                                  {" "}
                                  <button
                                    onClick={(e) => toggleDescription(task._id, e)}
                                    style={{
                                      padding: "2px 8px",
                                      fontSize: "12px",
                                      border: "1px solid #ddd",
                                      borderRadius: "4px",
                                      backgroundColor: "#f5f5f5",
                                      cursor: "pointer",
                                      color: "#333",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Show Less
                                  </button>
                                </>
                              )}
                            </>
                          );
                        })()
                      ) : (
                        <span>No description provided</span>
                      )}
                    </p>
                    <p>
                      <strong>Created At :</strong>{" "}
                      {new Date(task.createdAt).toLocaleString()}
                    </p>
                    <p>
                      <strong>Completed :</strong>{" "}
                      {task.isCompleted ? "Yes" : "No"}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Assigned By :</strong>{" "}
                      {task.assignedBy
                        ? formatText(
                            userMap[task.assignedBy]?.name || "Unknown"
                          )
                        : "Not Specified"}
                    </p>
                    <p>
                      <strong>Court Ref :</strong> {task.courtRef}
                    </p>
                    <p>
                      <strong>Due Date :</strong>{" "}
                      {new Date(task.dueDate).toLocaleString()}
                    </p>
                    <p>
                      <strong>Updated At :</strong>{" "}
                      {new Date(task.updatedAt).toLocaleString()}
                    </p>
                    {task.document && (
                      <p>
                        <strong>Document :</strong>{" "}
                        <a
                          href={`${process.env.REACT_APP_BACKEND_MAIN_URL_PATH}ftp/view/${task.document}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Document
                        </a>
                      </p>
                    )}
                  </div>
                </div>

                <div className="editdel">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setModalTab("Tasks");
                      setShowModal(true);
                      onEditTask(task);
                    }}
                    className="editbtn"
                  >
                    <BiEdit size={16} />
                  </button>
                  <button
                    onClick={(e) =>
                      handleDeleteClick(e, task._id, task.taskName)
                    }
                    className="delbtn"
                  >
                    <BiTrash size={16} />
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
      <DeleteConfirmationModal
        isOpen={deleteModal.isOpen}
        itemType={`this task "${deleteModal.taskName}"`}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />
    </>
  );
};
